var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"basic"},[_c('el-form',[_c('el-row',{attrs:{"gutter":20}},_vm._l((_vm.basic.fields),function(item,index){return _c('el-col',{key:item.id,attrs:{"span":24}},[_c('field-item',{attrs:{"index":index}})],1)}),1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }